import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWN511F1 (客訴單-採購組長核准)
// ============================================================

export interface ApproveCandidate {
  fn110_01: string;   // 客訴單號
  fn110_11: string;   // 客訴日期
  fn110_17: string;   // 客訴廠商總額
  fn110_pay: string;  // 賠償客戶金額合計
  fn110_8111: string; // 採購組長意見說明
}

export interface QueryResponse {
  items: ApproveCandidate[];
  total: number;
}

export interface ApproveItem {
  no: string;      // fn110_01 客訴單號
  opinion: string; // fn110_8111 採購組長意見說明
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwn511Api = {
  /** Query complaint records eligible for purchase-team-lead approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwn511/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected complaint records with per-item opinions.
   * confirmed:true mirrors the Modal.confirm dialog the user already went
   * through in PWN511Form (FoxPro's PWU016F2-style confirm gate) — the
   * backend does not yet require this field (disclosed gap, see
   * contexts/erp-contracts/forms/pwn511f1/control.contract.yaml), but the
   * frontend sends it so the wire shape already matches every other
   * CHAIN-16/18/01 batch-reversal sibling (n5m3Api/pwn5n1Api/pwn5mbApi)
   * once backend enforcement lands. */
  async approve(items: ApproveItem[], opinion?: string): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwn511/approve', { items, opinion: opinion || '', confirmed: true });
    return res.data;
  },
};
